export const PUBLIC_ORIGIN = "https://itsaboutyourmindset.com";
export const APP_ORIGIN = PUBLIC_ORIGIN;
const legacyAppHost = "app.itsaboutyourmindset.com";

const accountPaths = ["/access", "/auth/callback", "/dashboard", "/tenant-admin", "/team", "/messages", "/superadmin", "/docs", "/security", "/contact-widget-settings", "/recording-capture.html"];
const publicPaths = new Set(["/", "/features", "/apps", "/platform", "/developers", "/support", "/privacy", "/terms", "/account-deletion"]);
const currentHost = () => typeof window === "undefined" ? "" : window.location.hostname;

export function isPublicMarketingHost(hostname = currentHost()) {
  return hostname === "itsaboutyourmindset.com" || hostname === "www.itsaboutyourmindset.com" ||
    hostname === "mindset-public.pages.dev" || hostname.endsWith(".mindset-public.pages.dev");
}

export function accountHref(href: string, hostname = currentHost()) {
  if ((!isPublicMarketingHost(hostname) && hostname !== legacyAppHost) || !href.startsWith("/") || href.startsWith("//")) return href;
  const url = new URL(href, APP_ORIGIN);
  if (!accountPaths.some(path => url.pathname === path || url.pathname.startsWith(`${path}/`))) return href;
  return hostname === "itsaboutyourmindset.com" ? href : url.href;
}

export function marketingHref(href: string, hostname = currentHost()) {
  if (hostname !== legacyAppHost || !href.startsWith("/") || href.startsWith("//")) return href;
  const url = new URL(href, PUBLIC_ORIGIN);
  return publicPaths.has(url.pathname.replace(/\/+$/u, "") || "/") ? url.href : href;
}

export function developerHref(href: string, hostname = currentHost()) {
  if (isPublicMarketingHost(hostname) || hostname === legacyAppHost) {
    const url = new URL(href, APP_ORIGIN);
    const section = ["#api", "#sdks", "#onboarding"].includes(url.hash) ? url.hash : "#api";
    return `${APP_ORIGIN}/docs${section}`;
  }
  return accountHref(href, hostname);
}
